import { HttpClient } from '../httpClient';
import StudentStatusesResponse from '../responses/studentStatusesResponse';

const httpClient = new HttpClient();

export const getStudentStatuses = async () => {
  return httpClient.get<StudentStatusesResponse>({
    url: '/v1/studentStatuses',
    requiresToken: true,
  });
};
